export default __webpack_public_path__ + "static/media/760.28925e76.png";